import React from 'react'
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '../../../js/AppState';
import Popup from '../../shared/Popup/Popup';

import './PopupOrientation.css'
import Texts from 'react-sdk/Texts';

const PopupOrientation = () => {

  console.log("PopupOrientation")

  function handleClose() {
    PopupsManager.close(POPUPS.ORIENTATION)
  }

  return (
    <div className="PopupOrientation" >        
        <div className="Popup" >
          <div className="Popup-close" onClick={() => handleClose() }><p>&times;</p></div>
          <div className="content" >
            <h2>{Texts.get("orientation-title")}</h2>
            <div className="text" dangerouslySetInnerHTML={{__html: Texts.get("orientation-text")}} />
        </div>
      </div>
    </div>
  );
};

export default PopupOrientation;
